import logo from './logo.png'
import add_icon from './add_icon.png'
import order_icon from './order_icon.png'
import profile_image from './profile_image.png'
import upload_area from './upload_area.png'
import parcel_icon from './parcel_icon.png'
import table_resrvation from './table-reservation.png'
import user_data from "./user_data.png"

export const assets ={
    logo,
    add_icon,
    order_icon,
    profile_image,
    upload_area,
    parcel_icon,
    table_resrvation,
    user_data
}

export const url = 'http://localhost:4000'